/// <reference types="vite-plugin-svgr/client" />
import { category as BudgetCategory } from '@/__generated__/requests'

import EntertainmentIcon from '@/assets/icons/budget/budgetCategoryEntertainment.svg?react'
import FoodIcon from '@/assets/icons/budget/budgetCategoryFood.svg?react'
import HousingIcon from '@/assets/icons/budget/budgetCategoryHousing.svg?react'
import MedicalIcon from '@/assets/icons/budget/budgetCategoryMedical.svg?react'
import OtherIcon from '@/assets/icons/budget/budgetCategoryOther.svg?react'
import TransportationIcon from '@/assets/icons/budget/budgetCategoryTransportation.svg?react'

export function getBudgetCategoryIcon(category: BudgetCategory) {
  switch (category) {
    case BudgetCategory.FOOD:
      return FoodIcon
    case BudgetCategory.ENTERTAINMENT:
      return EntertainmentIcon
    case BudgetCategory.TRANSPORTATION:
      return TransportationIcon
    case BudgetCategory.MEDICAL:
      return MedicalIcon
    case BudgetCategory.HOUSING:
      return HousingIcon
    case BudgetCategory.OTHER:
      return OtherIcon
    default:
      return OtherIcon
  }
}
